export enum ECompanionNumberType {
  SingleValue = 0,
  MathFormula = 1,
}


